export var NavVariants = {
  default: 'default',
  simple: 'simple',
  horizontal: 'horizontal',
  tertiary: 'tertiary'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Nav/NavVariants.js
// module id = 120
// module chunks = 0